module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "#/int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "#/c01"
    }
  }, [_vm._v("Tools & equipment")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "#/c02"
    }
  }, [_vm._v("Recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('a', {
    attrs: {
      "href": "#/c03"
    }
  }, [_vm._v("Cupcake recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Topping recipes")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Techniques")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Applying frostings")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Using sugarpaste")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creating features")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Special finishes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Presentation & display")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Storage & transportation")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('span', {
    attrs: {
      "href": "#/c35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Barnyard fun")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Little lambs")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Porky piggies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mooing cows")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Playful pups")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Busy blackbirds")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spaced out")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blast off!")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Space explorers")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Celestial sensation")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alien invasion")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('span', {
    attrs: {
      "href": "#/c46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dressing up")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Red alert!")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cops & robbers")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Super troopers")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Doctors & nurses")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pop idols")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('span', {
    attrs: {
      "href": "#/c52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fairytales & adventure")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wicked pirates")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Magical mermaids")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fabulous fairies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gallant knights")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sugarpaste quantities & colourings")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/supp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suppliers")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/cop",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "http://www.stitchcraftcreate.co.uk/bookclub",
      "target": "_blank"
    }
  }, [_vm._v("Bookstore")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 60
// module chunks = 0